/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Provider_FirefliesInputs */



/**
* | output |
* | --- |
* | "Fireflies.ai" |
*
* @param {Spaces_Provider_FirefliesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_provider_fireflies = /** @type {((inputs?: Spaces_Provider_FirefliesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Provider_FirefliesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fireflies.ai")
	return /** @type {LocalizedString} */ ("Fireflies.ai")
});